import { SignaturePad } from "@/components/contract/SignaturePad";
import { DetailsFields } from "@/components/contract/DetailsFields";

export const ParentSign = ({ parent, setParent }) => (
  <div data-testid="contract-parent-section" className="space-y-6 border-t border-[#1c1418]/20 pt-6">
    <div>
      <p className="font-display text-2xl uppercase">Parent or guardian · Genitore o tutore</p>
      <p className="mt-1 text-sm text-[#1c1418]/70">The model is under 18: a parent or legal guardian fills in their data and signs too, on this same page. La modella è minorenne: anche un genitore o tutore legale inserisce i suoi dati e firma.</p>
    </div>
    <DetailsFields prefix="contract-parent" value={parent.details} onChange={(details) => setParent((p) => ({ ...p, details }))} />
    <SignaturePad testid="parent-signature-pad" hint="Parent signs here with mouse or finger" onChange={(sig) => setParent((p) => ({ ...p, sig }))} />
    <label className="flex items-start gap-3 text-sm">
      <input type="checkbox" required checked={parent.accept} onChange={(e) => setParent((p) => ({ ...p, accept: e.target.checked }))}
        data-testid="contract-parent-accept-checkbox" className="mt-1 h-4 w-4 accent-[#1c1418]" />
      As parent or legal guardian I have read the contract and I accept it. Come genitore o tutore legale ho letto il contratto e lo accetto.
    </label>
  </div>
);
